<template>
    <div :class="{
        'pp-ui-bar': applyStyles,
        'pp-ui-clickable': interactive}">
        <slot>
            <div ref='container' class="pp-ui-bar-container"
                 @click="handleClick"
                 @mousedown="startDrag"
                 @mouseleave="stopDrag(null, true)"
                 @mousemove="startDrag">
                <div ref='bar' class='pp-ui-bar-range pp-ui-bar-range-total'>
                </div>
                <div class='pp-ui-bar-range pp-ui-bar-range-progress'
                     :class="{'pp-ui-bar-range-progress-animate': !isDragging && !isTouched}"
                     :style="{right: 100-progress + '%'}">
                </div>

                <div v-if="interactive" class="pp-ui-bar-range-thumb pp-ui-bar-range-thumb-background"
                     :class="{
                        'pp-ui-bar-range-thumb-background-drag': isDragging,
                        'pp-ui-bar-range-thumb-background-touch': isTouched
                     }"
                     :style="{left: progress + '%'}">
                </div>

                <div class='pp-ui-bar-range pp-ui-bar-ad-marker'
                     v-for="(c, i) in player.ad.cuePoints"
                     v-bind:key="i"
                     :style="{left: adPositionRelative(c) + '%'}">
                </div>

                <div v-if="interactive" class="pp-ui-bar-range-thumb pp-ui-bar-range-thumb-foreground"
                     :class="{
                        'pp-ui-bar-range-thumb-foreground-drag': isDragging,
                        'pp-ui-bar-range-thumb-foreground-touch': isTouched
                     }"
                     :style="{left: progress + '%'}">
                </div>
            </div>
        </slot>
    </div>
</template>

<script>
  import {PPComponentMixin} from "../mixins";

  export default {
    name: "PPBarHorizontalSeek",
    mixins: [PPComponentMixin],
    props: {
      interactive: {
        type: Boolean,
        default: true
      },
      unsetHoverAfterSeek: {
        type: Boolean,
        default: false
      },
      periodTime: {
        type: Boolean,
        default: false
      },
      renderAdCues: {
        type: Boolean,
        default: true
      }
    },
    watch: {
      'player.currentTime': function (value) {
        if (!this.isDragging && !this.isTouched && !this.periodTime) {
          this.updateProgress(value);
        }
      },
      'player.periodTime': function (value) {
        if (!this.isDragging && !this.isTouched && this.periodTime) {
          this.updateProgress(value);
        }
      },
      'player.targetPosition': function (value) {

        if (!this.isDragging && !this.isTouched && value >= 0) {
          this.updateProgress(value);
        } else {
          if(value < 0 && this.unsetHoverAfterSeek) {
            this.player.hoverPosition = -1;
          }
        }
      }
    },
    data() {
      return {
        progress: 0,
        isDragging: false,
        isTouched: false
      }
    },
    mounted() {
      if (this.interactive) {
        this.$refs.container.addEventListener('touchstart', this.startTouch);
      }
    },
    beforeDestroy() {
      if (this.interactive) {
        this.$refs.container.removeEventListener('touchstart', this.startTouch);
      }
    },
    methods: {
      adPositionRelative(cuePosition) {
        return (100 * (cuePosition / this.getDuration())).toFixed(0);
      },
      updateProgress(value) {
        let seekRange = this.player.seekRange;
        let range = seekRange.end - seekRange.start;
        value = value - seekRange.start;
        this.progress = Math.min(
          100, Math.max(0, 100.0 * (value / range)));
      },
      getDuration() {
        return this.periodTime ? this.player.periodDuration : this.player.duration;
      },
      startTouch(e) {
        this.isTouched = true;
        this.startDrag(e);
      },
      startDrag(e) {
        if (!this.interactive) return;
        if(!this.isDragging) {
          this.isDragging = true;
          window.addEventListener('mouseup', this.stopDrag);
          window.addEventListener('mousemove', this.drag);
          window.addEventListener('touchend', this.stopDrag);
          window.addEventListener('touchmove', this.drag);
        }
        this.drag(e);
        this.$emit('hovering', true);
      },
      stopDrag(e, keepPosition) {
        if (!this.interactive) return;
        this.isDragging = false;
        this.isTouched = false;

        window.removeEventListener('mouseup', this.stopDrag);
        window.removeEventListener('mousemove', this.drag);
        window.removeEventListener('touchend', this.stopDrag);
        window.removeEventListener('touchmove', this.drag);

        if(!keepPosition) {
          // seek
          this.setPosition();
        } else {
          this.updateProgress(this.player.currentTime);
          this.player.hoverPosition = -1;
        }
      },
      drag(e) {
        if (!this.interactive) return;
        const p = this.$refs.container;
        if (!p) return;

        let bg = this.$refs.bar;
        let rect = bg.getBoundingClientRect();
        let width = rect.width;
        let x = e.pageX - rect.left;
        if (e.type === 'touchmove' || e.type === 'touchstart') {
          x = e.changedTouches[e.changedTouches.length - 1].pageX - rect.left;
        }

        this.progress = Math.min(100, Math.max(0, 100.0 * (x / width)));
        if (this.player) {
          let range = this.player.seekRange.end - this.player.seekRange.start;
          this.player.hoverPosition = this.player.seekRange.start + (range * (this.progress / 100.0));
        }

        if (e.type !== 'touchmove') {
          e.preventDefault && e.preventDefault();
          e.stopPropagation && e.stopPropagation();
          e.cancelBubble = true;
          e.returnValue = false;
        }
        return false;
      },
      handleClick(e) {
        if (!this.interactive) return;
        this.drag(e);
        return false;
      },
      setPosition() {
        if (this.player) {
          let range = this.player.seekRange.end - this.player.seekRange.start;
          this.player.targetPosition = this.player.seekRange.start + (range * (this.progress / 100.0));
          if (!this.unsetHoverAfterSeek) {
            this.player.hoverPosition = -1;
          }
        }
      }
    }
  }
</script>
